/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

interface IState {
  fittings?:any;
}

interface IProps {
  product?: any;
}

class FatsacFittings extends React.Component<IProps,IState> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount = async () => {
    let fatSacFittings:any = {
    	"ballast-floor-500":["(1) W730","(1) W749"],
    	"ballast-floor-800":["(1) W730","(1) W749"],
    	"ballast-v-drive":["(2) W730","(4) W731","(2) W749"],
    	"ballast-fat-brick":["(1) W730","(1) W749"],
    	"ballast-side-sac":["(2) W730","(2) W731","(2) W749"],
    	"ballast-tube-sac":["(1) W730","(1) W731","(1) W749"],
    	"ballast-locker-sac":["(1) W730","(2) W731","(1) W749"],
    	"ballast-open-bow":["(1) W730","(1) W731","(1) W749"],
    	"ballast-fat-sac":["(1) W730","(2) W731","(1) W749"],
    	"ballast-integrated-bow":["(1) W730","(3) W731","(1) W749"],
    	"ballast-w713":["(1) W730","(2) W731","(1) W749"],
    	"ballast-jumbo-surf":["(1) W730","(2) W731","(1) W749"]
    }
    if(this.props.product){
      if(this.props.product.attributes){
        if(this.props.product.attributes.slug){
          let fittings = fatSacFittings[this.props.product.attributes.slug];
          if(fittings)
          this.setState({
            fittings:fittings
          })
        }
      }
    }
  }

  public render(): JSX.Element {
    if(!this.state.fittings) return <span />;
    return (
      <div>
        <h6 className={"product-size-title tiny-top-margin"} style={{'marginBottom':'0px'}}>{'Available Fittings'}</h6>
        <div className={"product-size-container"}>
          {this.state.fittings.map((data:any,index:any) => {
            return(
              <div className={"product-size"}>
                {data}
              </div>
            )})}
        </div>
      </div>
    );
  }
}

export default FatsacFittings;
